class Q {
  static cond(op, field, value = undefined) {
    const cond = {
      isactive: true,
      oper: { sid: op },
      args: [
        { type: { sid: 'entitysid' }, value: field },
      ],
    }
    if (value !== undefined && value !== null) {
      cond.args.push({ type: { sid: 'value' }, value })
    }
    return cond
  }

  static orderBy(...fields) {
    return {
      orderby: {
        isActive: true,
        sorts: fields.map(f => {
          if (typeof f === 'string') {
            return {
              isActive: true,
              oper: { sid: 'asc' },
              entity: { sid: f },
            }
          }
          if (Array.isArray(f)) {
            const [field, dir] = f
            return {
              isActive: true,
              oper: { sid: (dir || 'asc').toLowerCase() },
              entity: { sid: field },
            }
          }
          throw new Error('Invalid orderBy argument')
        }),
      },
    }
  }

  static groupBy(...groups) {
    return {
      groupby: {
        isActive: true,
        groups: groups.map(g => {
          if (typeof g === 'string') {
            return {
              isActive: true,
              name: null,
              oper: { sid: 'sum' },
              entity: { sid: g },
            }
          } if (Array.isArray(g)) {
            const [field, op] = g
            return {
              isActive: true,
              name: null,
              oper: { sid: (op || 'sum').toLowerCase() },
              entity: { sid: field },
            }
          }
          throw new Error('Invalid groupBy argument')
        }),
      },
    }
  }

  static equals(field, value) {
    if (value === null || value === undefined) {
      return Q.cond('isnull', field)
    }
    return Q.cond('equal', field, value)
  }

  static notEquals(field, value) {
    return Q.cond('notequal', field, value)
  }

  static gt(field, value) {
    return Q.cond('greater', field, value)
  }

  static greater(field, value) {
    return Q.cond('greater', field, value)
  }

  static lt(field, value) {
    return Q.cond('less', field, value)
  }

  static less(field, value) {
    return Q.cond('less', field, value)
  }

  static geq(field, value) {
    return Q.cond('notless', field, value)
  }

  static notless(field, value) {
    return Q.cond('notless', field, value)
  }

  static leq(field, value) {
    return Q.cond('notgreater', field, value)
  }

  static notgreater(field, value) {
    return Q.cond('notgreater', field, value)
  }

  static isNotNull(field) {
    return Q.cond('isnotnull', field)
  }

  static isNull(field) {
    return Q.cond('isnull', field)
  }

  static and(conditions) {
    return {
      isactive: true,
      node: {
        isactive: true,
        oper: { sid: 'and' },
        nodes: [],
        conds: conditions,
      },
    }
  }

  static or(conditions) {
    return {
      isactive: true,
      node: {
        isactive: true,
        oper: { sid: 'or' },
        nodes: [],
        conds: conditions,
      },
    }
  }
}

function fmtVal(v) {
  if (v === null || v === undefined) return 'NULL'
  if (typeof v === 'number') return String(v)
  if (typeof v === 'boolean') return v ? 'TRUE' : 'FALSE'
  if (v instanceof Date && !isNaN(v)) return `"${v.toISOString().slice(0, 10)}"`
  const s = String(v)
  const iso = /^\d{4}-\d{2}-\d{2}(T.*)?$/.test(s)
  return `"${iso ? s.slice(0, 10) : s.replace(/"/g, '\\"')}"`
}

function opToken(op) {
  const m = {
    equal: '=',
    notequal: '!=',
    greater: '>',
    less: '<',
    notless: '>=',
    notgreater: '<=',
    isnull: 'IS NULL',
    isnotnull: 'IS NOT NULL',
    like: 'LIKE',
    ilike: 'ILIKE',
    in: 'IN',
    notin: 'NOT IN',
    between: 'BETWEEN',
  }
  return m[op] || op.toUpperCase()
}

function condToString(cond) {
  const op = cond?.oper?.sid?.toLowerCase()
  const args = cond?.args || []
  const field = args[0]?.value
  if (!op || !field) return ''
  if (op === 'isnull' || op === 'isnotnull') return `${field} ${opToken(op)}`
  const valArg = args[1]?.value
  if (op === 'in' || op === 'notin') {
    const arr = Array.isArray(valArg) ? valArg : [valArg]
    return `${field} ${opToken(op)} (${arr.map(fmtVal).join(', ')})`
  }
  if (op === 'between' && Array.isArray(valArg) && valArg.length === 2) {
    return `${field} ${opToken(op)} ${fmtVal(valArg[0])} AND ${fmtVal(valArg[1])}`
  }
  return `${field} ${opToken(op)} ${fmtVal(valArg)}`
}

function nodeToString(node) {
  if (!node) return ''
  const logic = (node.oper?.sid || 'and').toUpperCase()
  const parts = []
  const conds = node.conds || []
  const nodes = node.nodes || []

  conds.forEach(c => {
    if (c?.isactive === false) return
    if (c?.node) {
      const s = nodeToString(c.node)
      if (s) parts.push(`(${s})`)
      return
    }
    if (c?.oper?.sid) parts.push(condToString(c))
  })

  nodes.forEach(n => {
    if (n?.isactive === false) return
    const s = nodeToString(n.node || n)
    if (s) parts.push(`(${s})`)
  })

  return parts.filter(Boolean).join(` ${logic} `)
}

export function toWhereString(filter) {
  if (!filter) return ''
  const node = filter.node || filter
  return nodeToString(node)
}

export default Q
